import { render } from "./ApiErrorState.vue?vue&type=template&id=022adfba&scoped=true"
import script from "./ApiErrorState.vue?vue&type=script&lang=js"
export * from "./ApiErrorState.vue?vue&type=script&lang=js"

import "./ApiErrorState.vue?vue&type=style&index=0&id=022adfba&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3966428095/src/eelam-tv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-022adfba"]])

export default __exports__